export default {
  ADD_PARTICIPANT(state, participants) {
    state.participants.unshift(participants);
  },
  SET_PARTICIPANT(state, response) {
    state.single = Object.assign(state.single, response.data);
  },
  CLEAR_PARTICIPANTS(state) {
    state.participants = [];
    state.totalItems = 0;
  },
  SET_PARTICIPANTS(state, data) {
    state.totalItems = data.totalItems;
    state.participants = data.participants.map((v) => v.participant);
  },
  UPDATE_PARTICIPANT(state, participant) {
    state.single = Object.assign(
      { ...state.single },
      { id: participant.id, ...participant }
    );

    if (state.participants.length) {
      const participantIndex = state.participants.findIndex(
        (p) => p.id == participant.id
      );
      Object.assign(state.participants[participantIndex], participant);
    }
  },
  REMOVE_PARTICIPANT(state, participantsId) {
    const participantIndex = state.participants.findIndex(
      (p) => p.id == participantsId
    );
    state.participants.splice(participantIndex, 1);
    state.totalItems -= 1;
  },
  EXISTING_PARTICIPANT(state, { response, uuid }) {
    state.exists = false;
    state.wasExcluded = false;
    state.isVinculated = false;
    state.single = Object.assign(state.single, {});

    if (response && response.data) {
      if (!response.data.status) {
        state.wasExcluded = true;
      } else {
        state.exists = true;
        state.isVinculated = response.data.uuid.includes(uuid);
      }

      state.single = Object.assign(state.single, {
        id: response.data.id,
        name: response.data.name,
      });
    }
  },
  ASSOCIATE_PARTICIPANT(state, response) {
    state.single = Object.assign(state.single, response.data);
  },
  SMS_REQUESTED(state, response) {
    state.smsCodeSent = false;
    if (response && response.data) {
      state.smsCodeSent = response.data.mobile ? true : false;
    }
  },
  SMS_REQUESTED_CREATE(state, response) {
    state.smsCodeSent = false;
    if (response && response.data) {
      state.smsCodeSent = response.data.mobile ? true : false;
    }
  },
  TOKEN_GENERATED(state, newToken) {
    console.log(newToken)
    state.participantToken = newToken;
  },
};
